import React from 'react';
import Grid from "@material-ui/core/Grid";
import emptyBook from "../../../img/empty-book.png";
import styled from "styled-components";
import {Colors} from "../../../theme/colors";
import {CustomPencilIcon} from "../../ui-base/icons/custom-pencil-icon";
import {StyledButton} from "../../ui-base/button";
import {useHistory} from "react-router-dom";
import {Hidden} from "@material-ui/core";
import {useTranslation} from "react-i18next";

interface Props {
    title: string,
    description: string,
    showButton: boolean
}

export const EmptyBookShort: React.FC<Props> = ({title, description, showButton}) => {
    const history = useHistory();
    const { t } = useTranslation('author');

    return (
        <Grid className="empty-book-short">
            <StyledContainer item container direction={'row'}>
                <Hidden xsDown>
                    <StyledImageContainer item>
                        <StyledImg src={emptyBook}/>
                    </StyledImageContainer>
                </Hidden>

                <Grid item container xs direction={'column'} spacing={2} justifyContent={"center"}>
                    <Grid item>
                        <StyledTitle>{title}</StyledTitle>
                    </Grid>

                    <Grid item>
                        <StyledDescription>{description}</StyledDescription>
                    </Grid>

                    <Grid item>
                        {showButton && <StyledButton type={"button"} color={"violet"} onClick={() => {
                            history.push('/author/add-manuscript');
                        }} style={{marginRight: '1.5rem'}}>
                            <CustomPencilIcon style={{height: '16px', width: '15px', marginRight: '10px'}}/>
                            {t('addManuscript')}
                        </StyledButton>
                        }
                    </Grid>
                </Grid>
            </StyledContainer>
        </Grid>
    );
}

const StyledContainer = styled(Grid)`
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #E0E0E0;
  margin-top: 80px;
  padding: 0 20px 20px;
`;

const StyledImageContainer = styled(Grid)`
  margin-top: -50px;
  position: relative;
`;

const StyledImg = styled('img')`
  width: 175px;
`;

const StyledTitle = styled('h6')`
  font-weight: 600;
  font-size: 1.3rem;
  color: ${Colors.grayText};
`;

const StyledDescription = styled('p')`
  color: ${Colors.grayText};
`;
